import { render, staticRenderFns } from "./ClubEvents.vue?vue&type=template&id=ce41188a&scoped=true"
import script from "./ClubEvents.vue?vue&type=script&lang=js"
export * from "./ClubEvents.vue?vue&type=script&lang=js"
import style0 from "./ClubEvents.vue?vue&type=style&index=0&id=ce41188a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce41188a",
  null
  
)

export default component.exports